import { finallyChildrenRouterModeHandler } from '@utils/utils'

// 篮球 杯赛
import basketballCupRouter from '@router/basketball/cup_commonRouter'

// FIBAWA|国际篮联女子亚洲杯
import basketballCup_FIBAWARouter from '@router/basketball/cup_FIBAWA'
// FIBAWA|国际篮联女子亚洲杯
import basketballCup_FIBAMARouter from '@router/basketball/cup_FIBAMA'
const {
  FootballCupScheduleIndex,
  BasketballLeagueScheduleDetailIndex,
  BasketballCupScheduleDetailStartList,
  BasketballLeagueScheduleDetailPreMatch,
  BasketballLeagueScheduleDetailHotspots,
  BasketballLeagueScheduleDetailAnalysis,
  BasketballLeagueScheduleDetailStatistics,
  FootballCupTeamIndex,
  FootballCupScheduleDetailLineup,
  FootballCupTeamDetailIndex,
  FootballCupTeamDetailTeamData,
  FootballCupTeamDetailPlayerList,
  FootballCupTeamDetailMatchRecord,
  FootballCupLeagueTableIndex,
  FootballCupKnockoutRoundsIndex,
  BasketballLeagueRecordDetailIndex,
  BasketballLeagueRecordDetailDataOverview,
  BasketballLeagueRecordDetailTeamData,
  BasketballLeagueRecordDetailPlayerData,
  BasketballLeagueRecordDetailLineupData,
  FootballCupPlayerIndex,
  FootballCupPlayerDetailIndex,
  FootballCupSportsHallIndex,
  FootballCupBroadcastListIndex,
  FootballCupDataPackagListIndex,
  FootballCupProgramListIndex,
  FootballCupH5CompIndex,
} = basketballCupRouter
const { PlatfromBasketballFIBAWAFull } = basketballCup_FIBAWARouter
const { PlatfromBasketballFIBAMAFull } = basketballCup_FIBAMARouter
const pathModuleBase = 'platfromBasketballCupFull'
const diffCompetitionTypeArr = [
  {
    name: 'FIBAWA',
    pathModule: 'FIBAWomenAsiaCup',
    component: PlatfromBasketballFIBAWAFull,
  }, // 国际篮联女子亚洲杯
  {
    name: 'FIBAMA',
    pathModule: 'FIBAManAsiaCup',
    component: PlatfromBasketballFIBAMAFull,
  }, // 国际篮联女子亚洲杯
]

const baseChildren = [
  // pathModule 默认占位是FIFAWC
  {
    path: 'schedule', //basketball/cup/赛程
    name: 'scheduleIndex', // 最终生成的name是 'scheduleIndex_FIFAWC'
    component: FootballCupScheduleIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'schedule'],
      requireLogin: false,
      title: '赛程',
    },
  },
  {
    path: 'scheduleDetail', //basketball/cup/赛程详情
    redirect: { name: 'scheduleDetailStartList' },
    name: 'scheduleDetailIndex',
    component: BasketballLeagueScheduleDetailIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'schedule'],
      requireLogin: false,
    },
    children: [
      {
        path: 'AIForwardLooking', //basketball/league/赛程详情-AI前瞻
        name: 'scheduleDetailPreMatch',
        component: BasketballLeagueScheduleDetailPreMatch,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'startList', //basketball/cup/赛程详情-出场名单
        name: 'scheduleDetailStartList',
        component: BasketballCupScheduleDetailStartList,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'preMatch', //basketball/league/赛程详情-赛前
        name: 'scheduleDetailPreMatch',
        component: BasketballLeagueScheduleDetailPreMatch,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'analysis', //basketball/league/赛程详情-数据分析
        name: 'scheduleDetailAnalysis',
        component: BasketballLeagueScheduleDetailAnalysis,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      {
        path: 'statistics', //basketball/league/赛程详情-数据统计
        name: 'scheduleDetailStatistics',
        component: BasketballLeagueScheduleDetailStatistics,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'schedule'],
          requireLogin: false,
          title: '赛程详情',
        },
      },
      // {
      //   path: 'hotspots', //basketball/league/赛程详情-投篮热区
      //   name: 'scheduleDetailHotspots',
      //   component: BasketballLeagueScheduleDetailHotspots,
      //   meta: {
      //     pathModule: ['basketball', 'CBA', 'schedule'],
      //     requireLogin: false,
      //     title: '赛程详情',
      //   },
      // },
    ],
  },
  {
    path: 'team', //basketball/cup/球队
    name: 'teamIndex',
    component: FootballCupTeamIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'team'],
      requireLogin: false,
      title: '球队',
    },
  },
  {
    path: 'teamDetail', //basketball/cup/球队详情
    redirect: { name: 'teamDetailTeamData' },
    name: 'teamDetailIndex',
    component: FootballCupTeamDetailIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'team'],
      requireLogin: false,
    },
    children: [
      {
        path: 'teamData', //basketball/cup/球队详情-数据
        name: 'teamDetailTeamData',
        component: FootballCupTeamDetailTeamData,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
      {
        path: 'playerList', //basketball/cup/球队详情-名单
        name: 'teamDetailPlayerList',
        component: FootballCupTeamDetailPlayerList,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
      {
        path: 'matchRecord', //basketball/cup/球队详情-比赛记录
        name: 'teamDetailMatchRecord',
        component: FootballCupTeamDetailMatchRecord,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'team'],
          requireLogin: false,
          title: '球队详情',
        },
      },
    ],
  },
  {
    path: 'leagueTable', //basketball/cup/积分榜
    name: 'leagueTableIndex',
    component: FootballCupLeagueTableIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'leagueTable'],
      requireLogin: false,
      title: '积分榜',
    },
  },
  {
    path: 'knockoutRounds', //basketball/cup/淘汰赛
    name: 'knockoutRoundsIndex',
    component: FootballCupKnockoutRoundsIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'knockoutRounds'],
      requireLogin: false,
      title: '淘汰赛',
    },
  },
  {
    path: 'record', //basketball/league/数据中心
    redirect: { name: 'recordDetailDataOverview' },
    name: 'recordDetailIndex',
    component: BasketballLeagueRecordDetailIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'record'],
      requireLogin: false,
    },
    children: [
      {
        path: 'dataOverview', //basketball/league/数据中心-数据概览
        name: 'recordDetailDataOverview',
        component: BasketballLeagueRecordDetailDataOverview,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
      {
        path: 'teamData', //basketball/league/数据中心-球队数据
        name: 'recordDetailTeamData',
        component: BasketballLeagueRecordDetailTeamData,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
      {
        path: 'playerData', //basketball/league/数据中心-球员数据
        name: 'recordDetailPlayerData',
        component: BasketballLeagueRecordDetailPlayerData,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
      {
        path: 'lineupData', //basketball/league/数据中心-阵容数据
        name: 'recordDetailLineupData',
        component: BasketballLeagueRecordDetailLineupData,
        meta: {
          pathModule: ['basketball', 'FIBAWomenAsiaCup', 'record'],
          requireLogin: false,
          title: '数据中心',
        },
      },
    ],
  },
  {
    path: 'player', //basketball/cup/球员
    name: 'playerIndex',
    component: FootballCupPlayerIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'player'],
      requireLogin: false,
      title: '球员',
    },
  },
  {
    path: 'playerDetail', //basketball/cup/球员详情
    name: 'playerDetailIndex',
    component: FootballCupPlayerDetailIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'player'],
      requireLogin: false,
      title: '球员详情',
    },
  },
  {
    path: 'sportsHall', //足球 杯赛-场馆
    name: 'sportsHallIndex',
    component: FootballCupSportsHallIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'sportsHall'],
      requireLogin: false,
      title: '场馆',
    },
  },
  {
    path: 'broadcastList', //足球 杯赛-播出单
    name: 'broadcastListIndex',
    component: FootballCupBroadcastListIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'broadcastList'],
      requireLogin: false,
      title: '播出单',
    },
  },
  {
    path: 'dataPackagList', //数据包装
    name: 'dataPackagListIndex',
    component: FootballCupDataPackagListIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'dataPackagList'],
      requireLogin: false,
      title: '数据包装',
    },
  },
  {
    path: 'programList', //节目单
    name: 'programListIndex',
    component: FootballCupProgramListIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'programList'],
      requireLogin: false,
      title: '节目单',
    },
  },
  {
    path: 'h5Comp', //足球 h5组件
    name: 'h5CompIndex',
    component: FootballCupH5CompIndex,
    meta: {
      pathModule: ['basketball', 'FIBAWomenAsiaCup', 'h5Comp'],
      requireLogin: false,
      title: 'h5组件',
    },
  },
]

const finallyChildrenRouterModeArr = finallyChildrenRouterModeHandler(
  diffCompetitionTypeArr,
  baseChildren
)
console.debug('finallyChildrenRouterModeArr:', finallyChildrenRouterModeArr)

const routerModeArr = diffCompetitionTypeArr.map((routerItem, routerIndex) => ({
  path: `/${routerItem.pathModule}`, // /FIBAWomenAsiaCup
  name: `${pathModuleBase}_${routerItem.name}`, // platfromBasketballCupFull_FIBAWA
  component: routerItem.component,
  children: finallyChildrenRouterModeArr[routerIndex],
}))

export default {
  basketball_FIBAWA_RouterMode: routerModeArr[0],
  basketball_FIBAMA_RouterMode: routerModeArr[1],
}
